export default defineNuxtPlugin(nuxtApp => { // FIXME: REMOVE PIXEL
  // Avoid duplicate loading
  if (typeof window !== 'undefined' && !window.fbq) {
    (function (f: any, b: Document, e: string, v: string, n?: any, t?: HTMLScriptElement, s?: Node) {
      if (f.fbq) return

      n = f.fbq = function () {
        if (n.callMethod) {
          n.callMethod.apply(n, arguments)
        } else {
          n.queue.push(arguments)
        }
      }

      if (!f._fbq) f._fbq = n

      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []

      t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v

      s = b.getElementsByTagName(e)[0]
      s?.parentNode?.insertBefore(t, s)
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
  }

  nuxtApp.provide('fbq', window.fbq)
})
